import { useEffect, useState } from "react";

const W = 1200, H = 628;

const REAL_ADS = [
  {
    brand: "TopRankPulse", url: "toprankpulse.com",
    bg: "#0B0B22", accent: "#A855F7", text: "#FFFFFF", sub: "#A5A3C9",
    tag: "AI VISIBILITY",
    headlineLines: ["73% of websites", "are invisible to AI."],
    sublineLines: ["ChatGPT recommends your competitor — not you.", "Free 30-second scan, no card."],
    cta: "Scan my site", shape: "pulse",
  },
  {
    brand: "Stavebné Dopyty", url: "stavebne-dopyty.sk",
    bg: "#0F1A14", accent: "#F59E0B", text: "#FFFFFF", sub: "#9CB4A0",
    tag: "STAVEBNÍCTVO · SK",
    headlineLines: ["Staviate dom?", "3 cenové ponuky", "do 24 hodín."],
    sublineLines: ["Zadarmo vás spojíme s 3 firmami vo vašom okolí.", "Vyberte si najlepšiu."],
    cta: "Získať ponuky", shape: "stripes",
  },
  {
    brand: "Martinus", url: "martinus.sk",
    bg: "#8B1A1A", accent: "#FACC15", text: "#FFF8E7", sub: "#F5C6A0",
    tag: "KNIHA TÝŽDŇA",
    headlineLines: ["Čítaš alebo žiješ?", "Obe naraz."],
    sublineLines: ["Bestseller týždňa — dnes −30 %.", "Doprava zdarma nad 25 €."],
    cta: "Kúpiť knihu", shape: "book",
  },
  {
    brand: "Alza", url: "alza.sk",
    bg: "#06111F", accent: "#00B1FF", text: "#FFFFFF", sub: "#9BB7CC",
    tag: "BLACK FRIDAY",
    headlineLines: ["48 hodín.", "1 247 produktov.", "Reálne zľavy."],
    sublineLines: ["MacBook, iPhone, Dyson, Lego.", "Doručenie už zajtra."],
    cta: "Pozrieť zľavy", shape: "grid",
  },
  {
    brand: "Tatra banka", url: "tatrabanka.sk",
    bg: "#0A1F3A", accent: "#00A3E0", text: "#FFFFFF", sub: "#A5C0D9",
    tag: "TATRA BANKA · HYPO",
    headlineLines: ["Hypotéka", "z mobilu", "za 8 minút."],
    sublineLines: ["Bez papierovania. Bez cesty do banky.", "Úrok od 3,89 %."],
    cta: "Vypočítať splátku", shape: "ring",
  },
];

function Decoration({ shape, accent }) {
  switch (shape) {
    case "pulse":
      return (
        <g opacity="0.8">
          <circle cx={820 + 340} cy={-120 + 340} r={340} fill={accent} opacity="0.16" />
          <circle cx={920 + 220} cy={-20 + 220} r={220} fill={accent} opacity="0.22" />
        </g>
      );
    case "stripes":
      return (
        <g>
          {Array.from({ length: 6 }).map((_, i) => (
            <rect key={i} x={720 + i * 60} y={-20} width={24} height={700}
              fill={accent} opacity={0.08 + i * 0.04}
              transform={`rotate(12 ${720 + i * 60 + 12} 330)`} />
          ))}
        </g>
      );
    case "book":
      return (
        <g transform="translate(920, 290) rotate(-8) translate(-920, -290)">
          <rect x={780} y={80} width={280} height={380} fill={accent} opacity="0.9" rx="4" />
          <rect x={830} y={120} width={230} height={320} fill="#FFFDF5" opacity="0.95" rx="3" />
          <text x={945} y={270} fill="#8B1A1A" fontSize="34" fontWeight="900" fontFamily="Inter"
                textAnchor="middle">BEST</text>
          <text x={945} y={310} fill="#8B1A1A" fontSize="34" fontWeight="900" fontFamily="Inter"
                textAnchor="middle">SELLER</text>
        </g>
      );
    case "grid":
      return (
        <g>
          {Array.from({ length: 15 }).map((_, n) => {
            const r = Math.floor(n / 3), col = n % 3;
            const op = 0.08 + ((r + col) % 3) * 0.08;
            return <rect key={n} x={780 + col * 120} y={40 + r * 120}
              width={100} height={100} fill={accent} opacity={op} rx="8" />;
          })}
        </g>
      );
    case "ring":
      return (
        <g>
          <circle cx={820 + 220} cy={80 + 220} r={220} fill="none" stroke={accent} strokeWidth="2" opacity="0.4" />
          <circle cx={860 + 180} cy={120 + 180} r={180} fill="none" stroke={accent} strokeWidth="2" opacity="0.6" />
          <circle cx={900 + 140} cy={160 + 140} r={140} fill={accent} opacity="0.22" />
        </g>
      );
    default: return null;
  }
}

function AdSVG({ ad }) {
  const ctaW = Math.max(260, ad.cta.length * 22);
  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      width="100%"
      preserveAspectRatio="xMidYMid meet"
      style={{ display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0" y="0" width={W} height={H} fill={ad.bg} />

      <Decoration shape={ad.shape} accent={ad.accent} />

      {/* Eyebrow */}
      <rect x={60} y={64} width={12} height={14} fill={ad.accent} rx="2" />
      <text x={82} y={78} fill={ad.accent} fontSize="18" fontWeight="700"
            fontFamily="Inter, system-ui, sans-serif" letterSpacing="2">
        {ad.tag}
      </text>

      {/* Headline */}
      {ad.headlineLines.map((l, i) => (
        <text key={i} x={60} y={180 + i * 80} fill={ad.text}
              fontSize="72" fontWeight="900"
              fontFamily="Inter, system-ui, sans-serif">{l}</text>
      ))}

      {/* Subline */}
      {ad.sublineLines.map((l, i) => (
        <text key={i} x={60} y={H - 240 + i * 32} fill={ad.sub}
              fontSize="22" fontFamily="Inter, system-ui, sans-serif">{l}</text>
      ))}

      {/* CTA pill */}
      <rect x={60} y={H - 130} width={ctaW} height={68} rx="34" fill={ad.accent} />
      <text x={60 + ctaW / 2} y={H - 86} fill={ad.bg}
            fontSize="24" fontWeight="800"
            fontFamily="Inter, system-ui, sans-serif"
            textAnchor="middle">{ad.cta}</text>

      {/* URL */}
      <text x={60 + ctaW + 20} y={H - 86} fill={ad.sub} opacity="0.9"
            fontSize="18" fontWeight="600"
            fontFamily="Inter, system-ui, sans-serif">{ad.url}</text>
    </svg>
  );
}

export default function LivePreview() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => setIdx((i) => (i + 1) % REAL_ADS.length), 4200);
    return () => clearInterval(iv);
  }, []);

  const cur = REAL_ADS[idx];

  return (
    <div
      data-testid="ads-live-preview"
      style={{ position: "relative", width: "100%", maxWidth: 620, marginLeft: "auto" }}
    >
      <div style={{
        background: "linear-gradient(180deg, #1d1d33 0%, #14142a 100%)",
        borderRadius: 18, padding: "14px 14px 16px",
        border: "1px solid #2a2a45",
        boxShadow: "0 30px 90px rgba(0,0,0,0.55), 0 0 0 1px rgba(168,85,247,0.12)",
      }}>
        <div style={{ display: "flex", gap: 6, alignItems: "center", paddingBottom: 10 }}>
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#ff5f57" }} />
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#febc2e" }} />
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#28c840" }} />
          <span style={{
            marginLeft: 12, flex: 1, padding: "4px 12px",
            background: "#0b0b18", borderRadius: 999,
            color: "#7a7a99", fontSize: 12, fontFamily: "ui-monospace, monospace",
            border: "1px solid #1e1e35",
            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
          }}>
            ads-creator.toprankpulse.com/editor/{cur.url.split(".")[0]}
          </span>
          <span data-testid={`ads-live-brand-${idx}`} style={{
            fontSize: 11, color: "#a0a0c0", fontWeight: 700,
            letterSpacing: 0.5, textTransform: "uppercase", whiteSpace: "nowrap",
          }}>
            Live · {cur.brand}
          </span>
        </div>

        <div style={{
          position: "relative", width: "100%",
          borderRadius: 10, overflow: "hidden", background: cur.bg,
          lineHeight: 0, transition: "background 0.4s ease",
        }}>
          <AdSVG ad={cur} />
          <div style={{
            position: "absolute", bottom: 10, right: 10,
            background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)",
            color: "#fff", fontSize: 10, fontWeight: 700,
            padding: "4px 10px", borderRadius: 999,
            letterSpacing: 0.4, textTransform: "uppercase",
          }}>
            Real ad · {cur.brand}
          </div>
        </div>

        <div style={{ display: "flex", gap: 6, justifyContent: "center", paddingTop: 12 }} data-testid="ads-live-dots">
          {REAL_ADS.map((_, i) => (
            <button key={i}
              aria-label={`Ad ${i + 1}`}
              onClick={() => setIdx(i)}
              style={{
                width: i === idx ? 22 : 8, height: 8, borderRadius: 4,
                background: i === idx ? "#a855f7" : "#2a2a45",
                border: 0, cursor: "pointer",
                transition: "all 0.25s ease", padding: 0,
              }}
            />
          ))}
        </div>
      </div>

      <div style={{
        position: "absolute", top: -12, left: -12,
        background: "linear-gradient(90deg, #a855f7, #7c3aed)",
        color: "#fff", padding: "6px 12px",
        borderRadius: 999, fontSize: 11, fontWeight: 700,
        letterSpacing: 0.6, textTransform: "uppercase",
        boxShadow: "0 8px 24px rgba(168,85,247,0.4)",
      }}>
        ✨ Made in Ads Creator
      </div>
    </div>
  );
}
